<template>
  <div v-if="canChangeFullness">
    <b-dropdown variant="primary" text="Set Fullness" menu-class="pl-0">
      <b-dropdown-item
        v-for="full in fullnessList"
        :key="full.value"
        @click="
          selectedFullness = full.label;
          setFullnessConfirmation();
        "
        >{{ full.label }}</b-dropdown-item
      >
    </b-dropdown>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="setFullness"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import fullnessData from "@/config/fullness.json";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "FullnessDropdown",
  props: {
    barrelId: {
      required: true,
      type: String,
    },
    fullness: {
      required: false,
      type: String,
    },
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  data() {
    return {
      selectedFullness: "",
      setting: false,
    };
  },
  computed: {
    fullnessList() {
      if (this.fullness)
        return fullnessData.filter((data) => {
          return (
            parseInt(data.label.replace("%", "")) >
            parseInt(this.fullness.replace("%", ""))
          );
        });
      return fullnessData;
    },
    canChangeFullness() {
      return this.fullness != "100%";
    },
  },
  methods: {
    setFullnessConfirmation() {
      if (this.selectedFullness != this.fullness)
        this.showConfirmationModal({
          title: "Set Barrel Fullness",
          message: `Are you sure you want to set the barrel fullness to <b><em>${this.selectedFullness}</em></b>?`,
        });
    },
    async setFullness() {
      try {
        this.setting = true;
        this.startConfirmationLoading();
        let result = await ApiService.Instance.setBarrelFullness({
          barrelId: this.barrelId,
          barrelFullness: this.selectedFullness,
        });
        if (result) {
          this.showNotifier({
            message: `Successfully Set Fullness`,
            snackbarType: "success",
          });
          this.$emit("updated");
          this.selectedFullness = "";
        }
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Set Fullness`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
      this.setting = false;
    },
  },
  beforeMount() {
    this.selectedFullness = this.fullness;
    },
});
</script>

<style></style>
